import { IRackItem } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/RackItem/RackItem.props";

export type IUnrackItem = Omit<IRackItem, "pos" | "miner_id">;

export enum ActionTypesUnallocatedMiners {
  SET_MINERS = "SET_MINERS",
  REMOVE_MINER = "REMOVE_MINER",
  ADD_MINER = "ADD_MINER",
  UNRACKS_INVALIDATE = "UNRACKS_INVALIDATE",
  REORDER_ITEMS = "REORDER_ITEMS",
  SET_MINER_COLOR = "SET_MINER_COLOR",
}

export interface ActionBaseUnallocatedMiners {
  readonly type: ActionTypesUnallocatedMiners;
}

export interface ActionUnracksInvalidate extends ActionBaseUnallocatedMiners {}
export interface ActionSetUnallocatedMiners
  extends ActionBaseUnallocatedMiners {
  readonly payload: IUnrackItem[];
}

export interface ActionRemoveUnallocatedMiner
  extends ActionBaseUnallocatedMiners {
  readonly payload: number;
}

export interface ActionAddUnallocatedMiner extends ActionBaseUnallocatedMiners {
  readonly payload: IUnrackItem;
}

export interface ActionReorderItems extends ActionBaseUnallocatedMiners {
  readonly payload: {
    placedId: number;
    draggedId: number;
  };
}

export interface ActionSetMinerColor extends ActionBaseUnallocatedMiners {
  readonly payload: {
    user_id: string;
    color: string;
  };
}
